import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/app.config';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { navItems } from './vertical/sidebar/sidebar-data';
import { navItemsFarmacy, navItemsWarehouse } from '../menus';
import { NavService } from '../../services/nav.service';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './vertical/sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './vertical/header/header.component';
import { AppHorizontalHeaderComponent } from './horizontal/header/header.component';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './shared/customizer/customizer.component';
import { navItemsDoctorConsultory, navItemsDoctorConsultoryWithOutCurrentConsulting } from '../menus';
import { ChageItemsMenuService } from './shared/services/chage-items-menu.service';
import { navItemsConsultoryWithExternalAndInternal, navItemsConsultoryWithInternalWithOutExternal } from '../menus';
import { ChangeMenuInternalConsultationService } from './shared/services/change-menu-internal-consultation.service';
import { navItemsAdministrativeDirection } from '../menus';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

// for mobile app sidebar
interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-full',
  standalone: true,
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    AppBreadcrumbComponent,
    CustomizerComponent
  ],
  templateUrl: './full.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
})
export class FullComponent implements OnInit {

  navItems = navItems;

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav;
  resView = false;
  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  //get options from service
  options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  public subscription: Subscription;  

  typeRole: string | null;
  patiendId: string | null;
  internalConsultationId : string | null;
  showElement = signal<boolean>(false)
  messageEnvironment = signal<string>('')

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  // for mobile app sidebar
  apps: apps[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-dd-chat.svg',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/apps/chat',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-dd-cart.svg',
      title: 'eCommerce App',
      subtitle: 'Buy a Product',
      link: '/apps/email/inbox',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-dd-invoice.svg',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/apps/invoice',
    },
    {
      id: 4,
      img: '/assets/images/svgs/icon-dd-date.svg',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/apps/calendar',
    },
    {
      id: 5,
      img: '/assets/images/svgs/icon-dd-mobile.svg',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/apps/contacts',
    },
    {
      id: 6,
      img: '/assets/images/svgs/icon-dd-lifebuoy.svg',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/apps/tickets',
    },
    {
      id: 7,
      img: '/assets/images/svgs/icon-dd-message-box.svg',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/apps/email/inbox',
    },
    {
      id: 8,
      img: '/assets/images/svgs/icon-dd-application.svg',
      title: 'Courses',
      subtitle: 'Create new course',
      link: '/apps/courses',
    },
  ];  
  
  profiledd: profiledd[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'My Profile',
      subtitle: 'Account Settings',
      link: '/',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-inbox.svg',
      title: 'My Inbox',
      subtitle: 'Messages & Email',
      link: '/apps/email/inbox',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-tasks.svg',
      title: 'My Tasks',
      subtitle: 'To-do and Daily Tasks',
      link: '/apps/taskboard',
    },
  ];

  constructor(
    private settings: CoreService,    
    private router: Router,
    private breakpointObserver: BreakpointObserver,    
    public chageItemsMenuService: ChageItemsMenuService,
    public changeMenuInternalConsultationService : ChangeMenuInternalConsultationService
  ) {

    this.subscription = this.chageItemsMenuService.getEvent().subscribe(() => {
      this.getTypeRole();
    });

    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];
        if (this.options.sidenavCollapsed == false) {
          this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
        }
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
      });

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // This is for scroll to top
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e) => {
        this.content.scrollTo({ top: 0 });
      });    
  }

  ngOnInit(): void {
    this.getTypeRole();
    this.initializeAutoTheme();
    this.setupThemeCheckInterval();
  }

  /**
   * Inicializa el tema automáticamente basado en la hora del día
   */
  initializeAutoTheme(): void {
    // Verificar si hay una preferencia guardada del usuario
    const savedTheme = localStorage.getItem('themePreference');
    
    if (savedTheme) {
      // Si hay preferencia guardada, usarla
      this.options.theme = savedTheme as 'light' | 'dark';
      this.settings.setOptions(this.options);
      this.toggleDarkTheme(this.options);
    } else {
      // Si no hay preferencia, aplicar tema automático basado en la hora
      const currentHour = new Date().getHours();
      const isNight = this.isNightTime(currentHour);
      const autoTheme = isNight ? 'dark' : 'light';
      
      // Solo cambiar si el tema actual es diferente al que debería ser
      if (this.options.theme !== autoTheme) {
        this.options.theme = autoTheme;
        this.settings.setOptions(this.options);
        this.toggleDarkTheme(this.options);
      }
    }
  }

  /**
   * Determina si es hora nocturna basado en la hora actual
   * Noche: 8:00 PM (20:00) - 6:00 AM (6:00)
   * Día: 6:00 AM (6:00) - 8:00 PM (20:00)
   */
  private isNightTime(hour: number): boolean {
    return hour >= 20 || hour < 6;
  }

  /**
   * Configura un intervalo para verificar y actualizar el tema cada hora
   */
  private setupThemeCheckInterval(): void {
    // Verificar cada hora si el tema debe cambiar
    setInterval(() => {
      const savedTheme = localStorage.getItem('themePreference');
      // Solo cambiar automáticamente si no hay preferencia guardada
      if (!savedTheme) {
        const currentHour = new Date().getHours();
        const isNight = this.isNightTime(currentHour);
        const shouldBeDark = isNight;
        const currentIsDark = this.options.theme === 'dark';
        
        // Solo cambiar si el tema actual no coincide con el que debería ser
        if (shouldBeDark !== currentIsDark) {
          this.options.theme = shouldBeDark ? 'dark' : 'light';
          this.settings.setOptions(this.options);
          this.toggleDarkTheme(this.options);
        }
      }
    }, 60 * 60 * 1000); // Verificar cada hora (60 minutos * 60 segundos * 1000 ms)
  }

  showSiteLegend(){
    const currentUrl = this.router.url;    
    if (currentUrl.includes('mds-backoffice-dev.dialy.mx')){      
      this.showElement.set(true);
      this.messageEnvironment.set('Estas trabajando en el ambiente de desarollo, todos los datos son fictisios')
    }

    if (currentUrl.includes('mds-backoffice-stg.dialy.mx')){      
      this.showElement.set(true);
      this.messageEnvironment.set('Estas trabajando en el ambiente de pruebas, todos los datos son fictisios')
    }
    
  }

  getTypeRole(): any[] {           
         
    this.typeRole = localStorage.getItem('role');
    this.patiendId = localStorage.getItem('patientId');
    this.internalConsultationId = localStorage.getItem('internalConsultationId');

    if(this.typeRole == 'Doctor'){      
      if(this.patiendId !== null && this.internalConsultationId !== null  ){
        this.navItems = navItemsConsultoryWithExternalAndInternal;        
      }

      if(this.patiendId == null && this.internalConsultationId == null  ){
        this.navItems = navItemsDoctorConsultoryWithOutCurrentConsulting;                
      }

      if(this.patiendId !== null && this.internalConsultationId == null  ){
        this.navItems = navItemsDoctorConsultory;        
        console.log('me ejecute');        
      }

      if(this.patiendId == null && this.internalConsultationId !== null  ){
        this.navItems =  navItemsConsultoryWithInternalWithOutExternal;        
      }      
    }

    if (this.typeRole == 'Administrator') {
      this.navItems = navItemsAdministrativeDirection;
      return this.navItems;
    }

    if (this.typeRole == 'PharmacyManager') {
      this.navItems = navItemsFarmacy;
      return this.navItems;
    }

    if (this.typeRole == 'WarehouseManager') {
      this.navItems = navItemsWarehouse;
      return this.navItems;
    }

    return [];
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }
}
